<div class="test-screen-container">
  <app-warning-banner *ngIf="isProctored"></app-warning-banner>

  <div class="test-header" *ngIf="assesmentData as quiz">
    <div class="test-info">
      <h1 class="test-title">{{ quiz.quiz_name }}</h1>
      <span class="test-subtitle">Exam Mode</span>
    </div>
    <div class="header-actions">
      <div class="timer-badge">
        <i class="fa-regular fa-clock"></i>
        <span>{{ timerDisplay }}</span>
      </div>
      <button class="btn-submit-header" (click)="submitTest()">
        <ng-container *ngIf="isSubmitting; else showButton">
          <span class="spinner-border spinner-border-sm"></span> Submitting...
        </ng-container>
        <ng-template #showButton> Submit Test</ng-template>
      </button>
    </div>
  </div>

  <div class="main-content">
    <div class="question-area card" *ngIf="assesmentData as quiz">
      <ng-container *ngIf="quiz.questions[currentQuestionIndex] as question">
        <div class="question-scroll-content">
          <div class="question-header">
            <span class="question-number">
              Question {{ currentQuestionIndex + 1 }} of
              {{ quiz.questions.length }}
            </span>

            <span class="difficulty-badge">
              {{ question.difficulty_level }}
            </span>
          </div>

          <div class="question-text">
            <app-question-blocks
              [blocks]="$any(question).question_blocks"
              [content]="cleanQuestionQuizOptionText(question.question_text)">
            </app-question-blocks>
            <div *ngIf="question.diagram_url || question.diagram_payload" class="mt-3 text-start">
              <img [src]="question.diagram_url || question.diagram_payload" alt="Question Image" class="img-fluid rounded" style="max-height: 250px; object-fit: contain;">
            </div>
          </div>

          <div
            class="options-list"
            *ngIf="question.question_type === 'MCQ' && question.options?.length"
          >
            <div
              class="option-item"
              *ngFor="let option of question.options; let i = index"
              [class.selected]="
                answers[question.question_id] === option.option_id
              "
              (click)="onSelectOption(question.question_id, option.option_id)"
            >
              <div class="option-label">
                <app-math-latex [content]="getOptionLabel(i)"></app-math-latex>
              </div>

              <div class="option-text">
                <app-question-blocks
                  [blocks]="$any(option).blocks"
                  [content]="option.text"
                  [diagrams]="[]">
                </app-question-blocks>
                <img
                  *ngIf="option.image_url && (!$any(option).blocks || $any(option).blocks.length === 0)"
                  [src]="option.image_url"
                  [alt]="option.text || 'option image'"
                  class="option-diagram" />
              </div>
            </div>
          </div>

          <!-- OPEN ENDED 
                    <div *ngIf="question.question_type === 'OPEN_ENDED'">
                        <textarea rows="4"
                                  placeholder="Write your answer..."
                                  (input)="onTextAnswer(question.question_id, $event)">
                        </textarea>
                    </div>-->
        </div>

        <div class="question-footer">
          <div class="left-controls">
            <button
              class="btn-review"
              [class.active]="reviewList.has(question.question_id)"
              (click)="toggleReview()"
            >
              <i
                [ngClass]="
                  reviewList.has(question.question_id)
                    ? 'fa-solid fa-flag'
                    : 'fa-regular fa-flag'
                "
              ></i>
              {{
                reviewList.has(question.question_id)
                  ? "Marked for Review"
                  : "Mark for Review"
              }}
            </button>

            <button
              class="btn-text"
              (click)="clearAnswer(question.question_id)"
              *ngIf="answers[question.question_id]"
            >
              Clear
            </button>
          </div>

          <div class="right-controls">
            <button
              class="btn-nav previous"
              (click)="prevQuestion()"
              [disabled]="currentQuestionIndex === 0"
            >
              <i class="fa-solid fa-chevron-left"></i> Previous
            </button>

            <button
              class="btn-nav next"
              (click)="
                shouldShowSubmitInFooter()
                  ? submitTest()
                  : nextQuestion()
              "
            >
              <ng-container
                *ngIf="!shouldShowSubmitInFooter()"
              >
                Save & Next <i class="fa-solid fa-chevron-right"></i>
              </ng-container>

              <ng-container
                *ngIf="shouldShowSubmitInFooter()"
              >
                Submit
              </ng-container>
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="sidebar" *ngIf="assesmentData as quiz">
      <div class="palette-card card">
        <h3 class="palette-title">Question Palette</h3>

        <div class="legends">
          <div class="legend-item">
            <span class="dot answered"></span>
            <span>Answered ({{ answeredCount }})</span>
          </div>
          <div class="legend-item">
            <span class="dot review"></span>
            <span>Review ({{ reviewCount }})</span>
          </div>
          <div class="legend-item">
            <span class="dot current"></span>
            <span>Current</span>
          </div>
          <div class="legend-item">
            <span class="dot not-answered"></span>
            <span>Not Answered</span>
          </div>
        </div>

        <div class="palette-grid">
          <button
            *ngFor="let q of quiz.questions; let i = index"
            class="palette-btn"
            (click)="goToQuestion(i)"
            [ngClass]="getQuestionStatus(q.question_id, i)"
          >
            {{ i + 1 }}
          </button>
        </div>
      </div>
    </div>

    <div class="camera-box" *ngIf="!isSubmitted && !isAssessmentBlocked && isProctored && proctoringConfig?.enable_camera !== false">
      <video #video autoplay muted playsinline></video>
      <div class="camera-status">you</div>
    </div>

    <div class="submit-overlay" *ngIf="isSubmitting">
      <div class="submit-box">
        <div class="spinner-border" role="status"></div>

        <ng-container *ngIf="!isEvaluating">
          <h2>Submitting your assessment...</h2>
          <p>
            Please do not refresh, go back, or close this tab.<br />
            Your responses are being securely saved and evaluated.
          </p>
        </ng-container>
        <ng-container *ngIf="isEvaluating">
          <h2>Evaluating your responses...</h2>
          <p>
            Our AI is reviewing your answers.<br />
            This may take a few moments. Please stay on this page.
          </p>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="fs-warning-overlay" *ngIf="showFullscreenWarning">
    <div class="fs-warning-box">
      <div class="fs-warning-icon">
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
          <circle cx="28" cy="28" r="28" fill="#FFF3CD" />
          <path
            d="M28 16v14"
            stroke="#F59E0B"
            stroke-width="3"
            stroke-linecap="round"
          />
          <circle cx="28" cy="36" r="2" fill="#F59E0B" />
        </svg>
      </div>

      <h2 class="fs-warning-title">Full Screen Mode</h2>
      <p class="fs-warning-subtitle">
        You must take this test in full screen mode.<br />
        Don't exit or escape this mode during the test.
      </p>

      <div class="fs-violation-badge">
        <span class="fs-violation-count">
          Violation {{ fullscreenViolationCount }} of
          {{ MAX_FULLSCREEN_VIOLATIONS }}
        </span>
      </div>

      <p class="fs-warning-note">
        If you minimize or exit full screen
        <strong>{{ MAX_FULLSCREEN_VIOLATIONS }} times</strong>, your assessment
        will be auto-submitted due to violation.
      </p>

      <button class="fs-return-btn" (click)="reEnterFullscreen()">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M8 3H5a2 2 0 0 0-2 2v3" />
          <path d="M21 8V5a2 2 0 0 0-2-2h-3" />
          <path d="M3 16v3a2 2 0 0 0 2 2h3" />
          <path d="M16 21h3a2 2 0 0 0 2-2v-3" />
        </svg>
        Return to Full Screen
      </button>
    </div>
  </div>
</div>
